// extracted by mini-css-extract-plugin
export var component = "ContactsModule-module--component--93k0-";